export const USER_ROLES = Object.freeze([
  {
    id: "admin",
    title: "Администратор",
  },
  {
    id: "head-of-department",
    title: "Тимлид",
  },
  {
    id: "pm",
    title: "Менеджер проектов",
  },
  {
    id: "gpm",
    title: "Главный менеджер проектов",
  },
  {
    id: "administrative-employee",
    title: "Административный сотрудник",
  },
  {
    id: "employee",
    title: "Сотрудник",
  },
  {
    id: null,
    title: "Роль не указана",
  },
]);

export const USER_ROLES_ARRAY = Array.from(USER_ROLES, (item) => ({
  id: item.id,
  title: item.title,
}));
